import { activeCommentAtom } from "@app/shared/atoms/comments-atom";
import { userAtom } from "@framework/config/atoms";
import { useComments } from "./use-comments";

export function useCommentForm(typeId: number, type: string) {
  const activeComment = activeCommentAtom.useValue();
  const user = userAtom.useValue();
  const { addComment, updateComment } = useComments(typeId, type);

  return {
    activeComment,
    cancelEditing: () => activeCommentAtom.reset(),
    isEditing: Boolean(activeComment),
    submitComment: activeComment ? updateComment : addComment,
    user,
  };
}
